import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Lightbox from 'react-images';
import { removeChildNode } from '../../utils/utils';
import { letsDrawSomeProject } from '../../../actions/district';
import { toggleDrawBuilding, drawBuildingGetPoint, drawBuildingData, drawBuildingPDF, drawBuildingValidate } from '../../../actions/mapTools';
import TextExpander from '../../utils/TextExpander';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SideDescription.scss';
import { setPrintStatus } from '../../../actions/printSettings';
import BuildingDraw from './content/BuildingDraw.js';
import xbutton from './img/x.png';
import CmentarzeForm from './content/CmentarzeForm.js';

import fetch from '../../../core/fetch';
import SearchInvest from '../../SearchInvest/SearchInvest';
import { langTable } from '../../../constants';

const descImageMap = {
  "Miejsca i obiekty kultu religijnego": "kosciol.jpg",
  "Zabytki i obiekty historyczne": "zabytek.jpg",
  "Przyroda": "przyroda.jpg",
  "Placówki i obiekty użyteczności publicznej": "szkola.jpg",
  "Transport": "transport.jpg",
  "Miejsca sportu i wypoczynku": "rekreacja.jpg",
  "Kultura i rozrywka": "kultura.jpg",
  "Schronisko młodzieżowe": "schronisko.jpg",
  "Ośrodek wczasowy/pensjonat": "hotel.jpg",
  "Zajazd": "hotel.jpg",
  "Hotel": "hotel.jpg",
};

const isBrowser = typeof window !== 'undefined' && window !== null;

let Mapa, GeoJSON, TileLayer;

if (isBrowser) {
  Mapa = require('react-leaflet/lib/Map').default;
  TileLayer = require('react-leaflet/lib/TileLayer').default;
  GeoJSON = require('react-leaflet/lib/GeoJSON').default;
} else {
  Mapa, TileLayer = ' ';
}
const printMapStyle = {
  width: '100%',
  height: '250px',
  border: 'solid 2px black',
  zIndex: '402',
  position: 'relative',
};


let minimapa = null;

class SideDescription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      parcela: this.props.parcel_data,
      parcela2: this.props.data,
      toggleDrawPanel: false,
      szczegolyCont: false,
      kontaktCont: false,
      lightboxIsOpen: false,
      lightboxImages: null,
      lightboxChosenImg: null,
      lightboxCurrentImg: 0,
      sideDescription: this.props.sideDescription,
      intl: this.props.intl,
      einvestInfo: null,
    };
  }


  componentDidMount() {
    this.checkScroll();
    this.setRulesForDisplay();
    if (this.state.lightboxImages === undefined || this.state.lightboxImages === null) {
      // pobieramy zdjecia przypisane do ofert
      fetch('https://investinkrosno.pl/wp-json/zdjecia/v1/all').then(resp => {
        return resp.json();
      }).then(resp => {
        this.setState({ lightboxImages: resp });
      }).catch(err => console.info(err));
    }
    const idOferty = this.props.district.prefix === 'krosno' ? this.state.sideDescription.data.features[0].properties.id_oferty : null;
    if (
      (this.state.einvestInfo === undefined ||
      this.state.einvestInfo === null ||
      this.state.einvestInfo[0].id !== idOferty) &&
      this.props.district.prefix === 'krosno'
    ) {
      // pobieramy info o investycji
      fetch(`${process.env.API_URL}/einvest/${this.props.district.prefix}/info?id=${idOferty}`).then(resp => {
        return resp.json();
      }).then(resp => {
        this.setState({ einvestInfo: resp });
      }).catch(err => console.info(err));
    }
  }

  componentWillReceiveProps(nextProps) {
    JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data) ? this.setState({ parcela2: nextProps.data, toggleDrawPanel: false }) : null;
    JSON.stringify(this.props.parcel_data) !== JSON.stringify(nextProps.parcel_data) ?
      this.setState({ toggleDrawPanel: false })
    : null;
    JSON.stringify(this.props.sideDescription.invest) !== JSON.stringify(nextProps.sideDescription.invest) ?
      this.setState({ buildingDrawPanel: nextProps.sideDescription.invest })
    : null;
    JSON.stringify(this.props.sideDescription) !== JSON.stringify(nextProps.sideDescription) ?
      this.setState({ sideDescription: nextProps.sideDescription })
    : null;
    if (JSON.stringify(this.props.buildingDrawTool) !== JSON.stringify(nextProps.buildingDrawTool) &&
    (this.state.lightboxImages !== undefined && this.state.lightboxImages !== null)){
      let arr = [];
      this.state.lightboxImages.map((v, i) => {
        v.id_oferty == nextProps.data.features[0].properties.id_oferty ? arr.push({ src: v.img, caption: v.nazwa }) : null
      });
      if (arr.length > 0) {
        this.setState({
          lightboxChosenImg: arr
        })
      } else {
        this.setState({
          lightboxChosenImg: null
        })
      }
    }
    if (JSON.stringify(nextProps.intl) !== JSON.stringify(this.state.intl)) {
      this.setState({
        intl: nextProps.intl,
      });
    }
  }

  componentDidUpdate() {
    this.checkScroll();
    this.setRulesForDisplay();
  }

  // sets rules for display order:
  setRulesForDisplay = () => {
    // sets 'Nazwa pełna' on first place
    if (this.refs.nazwa_pelna !== undefined) {
      this.featureSection.insertBefore(this.refs.nazwa_pelna, this.featureSection.firstChild);
      // removes 'Nazwa pełna' title
      removeChildNode(this.refs.nazwa_pelna, 'desc-feat-title');
    }
    // sets 'Opis' on second place
    if (this.refs.opis !== undefined) {
      this.featureSection.insertBefore(this.refs.opis, this.featureSection.firstChild.nextSibling);
      // removes 'Opis' title
      removeChildNode(this.refs.opis, 'desc-feat-title');
    }
    // sets 'Opis pełny' after 'opis'
    if (this.refs.opis_pelny !== undefined) {
      this.featureSection.insertBefore(this.refs.opis_pelny, this.refs.opis.nextSibling);
    }
    // enables linking to website
    if (this.refs.strona_www !== undefined) {
      const www = this.refs.strona_www.querySelector('#strona_www');
      const wwwContent = www.innerHTML;
      www.innerHTML = '<a href="' + wwwContent + '">' + wwwContent + '</a>';
    }
  }

  checkScroll = () => {
    const sideDescrModal = this.sideDescrModal;
    const hasOverflowingChildren = sideDescrModal.offsetHeight < sideDescrModal.scrollHeight;
    const closeButton = document.getElementsByClassName('desc-close')[0];
    if (hasOverflowingChildren) {
      closeButton.classList.remove('desc-close-no-scroll');
      closeButton.classList.add('desc-close-scroll');
      sideDescrModal.classList.remove('no-scroll-style');
      sideDescrModal.classList.add('scroll-style');
    } else {
      sideDescrModal.classList.remove('scroll-style'); // checks if modal is bigger than browser, then sets appriopriate class
      sideDescrModal.classList.add('no-scroll-style');
      closeButton.classList.remove('desc-close-scroll');
      closeButton.classList.add('desc-close-no-scroll');
    }
  }

  handleClick = () => {
    this.props.closeSideDescription();
    this.props.toggleDrawBuilding(false);
    this.props.drawBuildingGetPoint([]);
    this.props.letsDrawSomeProject(false);
    this.setState({
      toggleDrawPanel: false,
    });
  }

  // Funkcja zaokrąglająca do podanych miejsc po przecinku
  round = (n, k) => {
    var factor = Math.pow(10, k);
    return Math.round(n*factor)/factor;
  }

  showBuidlingDrawPanel = () => {
    // odpalamy narzedzie do projektowania zarysu budynkow i "zerujemy" poprzednie pomiary
    this.props.letsDrawSomeProject(true);
  }

  gotoPrevious = () => {
		this.setState({
			lightboxCurrentImg: this.state.lightboxCurrentImg - 1,
		});
	}
	gotoNext = () => {
		this.setState({
			lightboxCurrentImg: this.state.lightboxCurrentImg + 1,
		});
	}

  renderEinvestInfo = () => {
    let langTable;
    if (this.props.intl.locale === 'pl-PL') {
      langTable = this.state.einvestInfo.pl;
    } else if (this.props.intl.locale === 'en-EN') {
      langTable = this.state.einvestInfo.en;
    } else if (this.props.intl.locale === 'de-DE') {
      langTable = this.state.einvestInfo.de;
    }
    return langTable.map((v, i) => {
      return (
        <div className="oboksiebie" key={i * 314}>
          <div className="dropdown-expander__content-kat">
            <div>
              <strong className="wjednejlini">
                {
                  Object.keys(v) !== '[NULL]' ? Object.keys(v) : ''
                }
              </strong>
            </div>
          </div>
          <div className="dropdown-expander__content-podkat">
            {
              Object.values(v)[0].map((z, j) => {
                return (
                  <div key={z.id + '_' + j + 'dropdown-expander'}>
                    <label >{z.subkategoria}</label>
                    <p><span className="">{z.tekst}</span></p>
                  </div>
                );
              })
            }
          </div>
        </div>
      );
    });
  }

  renderInvestName = (info) => {
    if (this.props.intl.locale === 'en-EN') {
      return info.nazwa_en;
    } else if (this.props.intl.locale === 'de-DE') {
      return info.nazwa_de;
    } else {
      // zwracamy Polski
      return info.nazwa;
    }
  }

  renderDescription = () => {
    // informacje w sidebarze o ofercie inwestycyjnej (Krosno)

    const header = {
      fontSize: '1.5em',
      fontWeight: '600',
      margin: '0 0 10px 0',
      textAlign: 'center',
      color: '#1b99fd',
    };
    if (this.state.sideDescription.contentType == 'zainwestowane'){
      return (
        <div className="dropdown-expander">
          <div key={this.state.intl.langKeys.istInwTitle} style={header}>{this.state.intl.langKeys.istInwTitle}</div>
          <div>
            <span key={this.state.intl.langKeys.nazwa} className="desc-feat-title parcel-data">{this.state.intl.langKeys.nazwa}:</span>
            <p className="text-content parcel-data">{this.state.sideDescription.data.nazwa}</p>
            <span key={this.state.intl.langKeys.branza} className="desc-feat-title parcel-data">{this.state.intl.langKeys.branza}:</span>
            <p className="text-content parcel-data">{this.state.sideDescription.data.branza}</p>
            <span key={this.state.intl.langKeys.opis} className="desc-feat-title parcel-data">{this.state.intl.langKeys.opis}:</span>
            <p className="text-content parcel-data">{this.state.sideDescription.data.opis}</p>
          </div>
        </div>);
    }
    const BuildingDrawButton = () => {
      const info = this.props.data.features[0].properties;
      const kontakt = this.props.data.features[0].properties.kontakt;
      const powierzchnia = info.powierzchnia / 10000;
      return (
        <div>
          <div style={header}>{this.renderInvestName(info)} <br/>({powierzchnia.toFixed(3)} ha)</div>
          <div className="dropdown-expander">
            <button onClick={() => { this.setState({ szczegolyCont: !this.state.szczegolyCont }); }}><span key={this.state.intl.langKeys.szczegoly} className="upText">{this.state.intl.langKeys.szczegoly}</span> &nbsp;<span className="glyphicon glyphicon-menu-down" /></button>
            <div className={`dropdown-expander__content ${this.state.szczegolyCont ? 'rozwin' : null}`}>
              {this.state.einvestInfo ? this.renderEinvestInfo() : null}
            </div>
          </div>
          <div className="dropdown-expander">
            <button key={this.state.intl.langKeys.kontakt} onClick={() => { this.setState({ kontakCont: !this.state.kontakCont }); }}><span className="upText">{this.state.intl.langKeys.kontakt}</span>&nbsp;<span className="glyphicon glyphicon-menu-down" /></button>
            <div className={`dropdown-expander__content ${this.state.kontakCont ? 'rozwin' : null}`}>
              <p><strong className="">{kontakt.stanowisko}</strong></p>
              <p>
                <strong>
                  <span className="">{kontakt.imie}</span>&nbsp;
                  <span className="">{kontakt.nazwisko}</span>
                </strong>
              </p>
              <p><span className="">{kontakt.telefon}</span></p>
              <p><span className="">{kontakt.email}</span></p>
              <div className="pionowo">
                <span className="">{kontakt.miejscowosc}</span>
                <span>
                  <span className="">ul.&nbsp;{kontakt.ulica}</span>&nbsp;
                  <span className="">{kontakt.nr_ulicy}</span>&nbsp;
                  {kontakt.nr_lokalu !== null ? <span className="">/{kontakt.nr_lokalu}</span> : null}
                </span>
                <span className="">{kontakt.kod}</span>
                <span className="">{kontakt.poczta}</span>
              </div>
            </div>
          </div>
          <button onClick={() => this.showBuidlingDrawPanel()} className="btn btn-primary btn-block custom-btn"><span className="upText">{this.state.intl.langKeys.zaprojektuj}</span></button>
          {this.state.lightboxChosenImg ?
            <div>
              <button onClick={() => this.setState({ lightboxIsOpen: true })} className="btn btn-info btn-block perfectCenter marginesy custom-btn">
                <span key={this.state.intl.langKeys.galeria} style={{ height: '100%', marginRight: '10px' }}>{this.state.intl.langKeys.galeria}</span>
                <span className="fa fa-file-image-o fa-2x" aria-hidden="true" />
              </button>
              <Lightbox
                currentImage={this.state.lightboxCurrentImg}
                images={this.state.lightboxChosenImg}
                isOpen={this.state.lightboxIsOpen}
                onClose={() => this.setState({ lightboxIsOpen: false })}
                onClickNext={() => this.setState({ lightboxCurrentImg: this.state.lightboxCurrentImg + 1 })}
					      onClickPrev={() => this.setState({ lightboxCurrentImg: this.state.lightboxCurrentImg - 1 })}
              />
            </div> : null }
          <p key={this.state.intl.langKeys.kartaInfo} className="karta-info" ><a href={info.www} target="_blanck" className=""><u className="upText">{this.state.intl.langKeys.kartaInfo}</u></a></p>
        </div>
      );
    };
    if (this.props.data.features[0].properties.id_oferty) {
      return <BuildingDrawButton />;
    }
    if (!Array.isArray(this.props.data) && this.props.parcelState !== true) {
      if (this.props.data.features) {
        let lengthFeatures = this.props.data.features.length - 1;
        const parcelArray = [
          {"": this.props.district.nazwa},
          {[this.state.intl.langKeys.obrebNr] : this.props.data.features[0].properties.nr_obrebu},
          {[this.state.intl.langKeys.dzialkaNr] : this.props.data.features[0].properties.nr_dzialki},
          {[this.state.intl.langKeys.przeznaczenie] : this.props.data.features[lengthFeatures/2].properties.opis},
          {[this.state.intl.langKeys.symbol] : this.props.data.features[lengthFeatures/2].properties.oznaczenie},
          {[this.state.intl.langKeys.powDzialki] : this.round(this.props.data.features[0].properties.powierzchnia, 2) + " m2"},
          {[this.state.intl.langKeys.dataUchwaleniaMpzp] : this.props.data.features[lengthFeatures].properties.data},
          {[this.state.intl.langKeys.uchwalaMpzp] : this.props.data.features[lengthFeatures].properties.numer_uchwaly},
          {[this.state.intl.langKeys.trescUchwalyMpzp] : this.props.data.features[lengthFeatures].properties.uchwala},
          {[this.state.intl.langKeys.rysunekMpzp] : this.props.data.features[lengthFeatures].properties.raster},
        ];
        const mappedFeatureMap = (
          <div className="feature-container">
            { parcelArray.map((k, v) => {
              if (Object.values(k)[0] !== (null || '' || undefined)) {
                return (
                  <div key={v}>
                    <span className="desc-feat-title parcel-data"><b>{Object.keys(k)}</b></span>
                    <p className={v == 0 ? 'city text-content parcel-data' : 'text-content parcel-data'}>
                    {v == 8 || v == 9 ? <a href={process.env.OLD_IHUB + '/upload/' + Object.values(k)} target="_blank">Pobierz</a> : Object.values(k)}
                    </p>
                  </div>
                );
              } else {
                return null;
              }
            })
            }
                    {this.props.currentComposition.nazwa == 'DECYZJE ŚU' ?
                <div>
                    <span className="desc-feat-title parcel-data">Numer decyzji</span>
                    <p className="text-content parcel-data">1/2011</p>
                    <span className="desc-feat-title parcel-data">Adres</span>
                    <p className="text-content parcel-data">Jana III Sobieskiego 1, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska</p>
                </div> : ''
              }

            {this.props.district.prefix == 'gmina_cieszanow' && this.props.data.dzialka == '2275' ?
              <div><span className="desc-feat-title parcel-data">Załączniki</span>
              <p className="text-content parcel-data">
                  <a target="_blank" href="http://mapa.inspire-hub.pl/upload/PRZEDSZKOLE_CIESZANOW.jpg">Zdjęcie</a>
                  <br />
                  <a target="_blank" href="http://mapa.inspire-hub.pl/upload/STATUT_CIESZANOW.pdf">Statut przedszkola</a>
              </p>
              </div> : ''}
          </div>
        );
        return mappedFeatureMap;
      } else {
        const pow = parseInt(this.props.data.powierzchnia);
        const parcelArray = [
          {"": this.props.district.nazwa},
          {"Obręb nr:" : this.props.data.obreb},
          {"Działka nr:" : this.props.data.dzialka},
          {"Powierzchnia:" : pow.toFixed(2)+" m2"},
        ];
        const mappedFeatureMap = (
          <div className="feature-container">
            { parcelArray.map((k, v) => {
              return (
                <div key={v}>
                  <span className="desc-feat-title parcel-data">{Object.keys(k)}</span>
                  <p className="text-content parcel-data">{Object.values(k)}</p>
                </div>
              );
            })
            }

            {this.props.district.prefix == 'gmina_cieszanow' && this.props.data.dzialka == '2275' ?
              <div><span className="desc-feat-title parcel-data">Załączniki</span>
              <p className="text-content parcel-data">
                  <a target="_blank" href="http://mapa.inspire-hub.pl/upload/PRZEDSZKOLE_CIESZANOW.jpg">Zdjęcie</a>
                  <br />
                  <a target="_blank" href="http://mapa.inspire-hub.pl/upload/STATUT_CIESZANOW.pdf">Statut przedszkola</a>
              </p>
              </div> : ''}

              {this.props.currentComposition.nazwa == 'DECYZJE ŚU' ?
                <div>
                    <span className="desc-feat-title parcel-data">Numer decyzji</span>
                    <p className="text-content parcel-data">1/2011</p>
                    <span className="desc-feat-title parcel-data">Adres</span>
                    <p className="text-content parcel-data">Jana III Sobieskiego 1, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska</p>
                </div> : ''
              }

            {this.props.district.prefix == 'gmina_cieszanow' && this.props.data.dzialka == '2275' ?
              <div><span className="desc-feat-title parcel-data">Załączniki</span>
              <p className="text-content parcel-data">
                  <a target="_blank" href="http://mapa.inspire-hub.pl/upload/PRZEDSZKOLE_CIESZANOW.jpg">Zdjęcie</a>
                  <br />
                  <a target="_blank" href="http://mapa.inspire-hub.pl/upload/STATUT_CIESZANOW.pdf">Statut przedszkola</a>
              </p>
              </div> : ''}
          </div>
        );
        return mappedFeatureMap;
      }
    } else if (this.props.parcelState !== true) {
      const featureKeys = this.props.propKeys.pois.data.props;
      const features = this.props.data;
      const featureMap = new Map(); // new ES6 syntax for Map, sets key and value together
      features.map(
        (item, index) => {
          featureMap.set(featureKeys[index], item);
        },
      );

      const mappedFeatureMap = [...featureMap]
        .filter(([key, value]) => value !== null && value !== '' && !['x', 'y ', 'id', undefined].includes(key))
        .map(([k, v]) =>
          <div key={k} ref={k} className="feature-container">
            <span className="desc-feat-title">{String.prototype.normalizePropertiesNames(k)}:</span>
            <TextExpander
              checkScroll={this.checkScroll}
              expId={k}
              expValue={v}
            >
              {v}
            </TextExpander>
          </div>,
        );
        {this.props.currentComposition.nazwa == 'DECYZJE ŚU' ?
        <div>
          <span className="desc-feat-title parcel-data">Numer decyzji</span>
          <p className="text-content parcel-data">1/2011</p>
          <span className="desc-feat-title parcel-data">Adres</span>
          <p className="text-content parcel-data">Jana III Sobieskiego 1, Cieszanów, gmina Cieszanów, powiat lubaczowski, województwo podkarpackie, 37-611, Polska</p>
        </div> : ''
        }
      return mappedFeatureMap;
    } else if (this.props.parcelState === true) {
      return (
        <div>
          <div style={{ fontSize: '1.5em' }}>Numery wybranych działek:</div>
          {this.props.data.features.map((v, i) => {
            return <div>{v.properties.nr_dzialki}</div>
          })}
        </div>
      );
    }
  }
  renderImage = () => {
    const currentCenter = this.props.routing.currentCenter;
    const currentZoom = this.props.routing.zoomLevel;
    if (!Array.isArray(this.props.data)) {
      minimapa = (
        <Mapa
          id="parcel-map"
          ref={m => { this.printmap = m; }}
          style={printMapStyle}
          center={currentCenter}
          zoom={currentZoom-3}
          animate
          dragging={false}
          boxZoom={false}
          zoomControl={false}
        >
          <TileLayer
            url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
          />
          {(this.props.parcel_data !== this.state.parcela) ?
            <GeoJSON
              ref={abc => { this.foundParcel = abc; }}
              pointToLayer={(geoJsonPoint, latlng) => this.pointToLayer(geoJsonPoint, latlng, 'parcels')}
              data={this.props.parcel_data}
            /> : null}
          {((this.props.data === this.state.parcela2) && this.props.data.features) ? (
          <GeoJSON
            ref={abc => { this.foundParcel = abc; }}
            pointToLayer={(geoJsonPoint, latlng) => this.pointToLayer(geoJsonPoint, latlng, 'parcels')}
            data={this.state.parcela2}
          />
          ) : null}
        </Mapa>
      );
    }

    const ImageName = descImageMap[this.props.data[1]] && descImageMap[this.props.data[1]] !== undefined ? descImageMap[this.props.data[1]] : 'POIgeneric.jpg';
    const imgUrl = require(`./img/${ImageName}`);

    if (!Array.isArray(this.props.data)) {
      return (
        <div style={{ margin: '5px' }}>
          {minimapa}
        </div>
      );
    } else {
      return (
        <img
          src={imgUrl}
          alt={this.props.data[1]}
          className="desc-pict"
        />
      );
    }
  }

  headerContent = () => {
    if ([
      'gmina_siekierczyn',
      'gmina_strzegom',
      'gmina_swierzawa',
      'gmina_zarow',
      'jawor',
      'swiebodzice'
    ].includes(this.props.district.prefix)){
      return <h2>Wyszukiwarka grobów</h2>
    }
    if (this.state.sideDescription.contentType == 'zainwestowane'){
      return <h2 key={this.state.intl.langKeys.istInw}>{this.state.intl.langKeys.istInw}</h2>
    }
    if (this.props.buildingDrawTool.limits) {return <h2 key={this.state.intl.langKeys.ofertaInvest}>{this.state.intl.langKeys.ofertaInvest}</h2>}
    else {
      return Array.isArray(this.props.data) ?
      <h2 key={this.state.intl.langKeys.opisObiektu}>{this.state.intl.langKeys.opisObiektu}</h2>
      : <h2 key={this.state.intl.langKeys.dzialkaEwi}>{this.state.intl.langKeys.dzialkaEwi}</h2>;
    }
  }

  projektHeader = () => {
    return <h2 key={this.state.intl.langKeys.zaprojektujInwestycje}>{this.state.intl.langKeys.zaprojektujInwestycje}</h2>;
  };

  headerSearch = () => {
    return <h4 key={this.state.intl.langKeys.wyszOfert}>{this.state.intl.langKeys.wyszOfert}</h4>;
  }

  ograniczeniaKondygnacji = () => {
    // this.state.buildingDrawTool.limits.ograniczenia.
  }

  render() {
    return (
      <div className={
        [
          'gmina_siekierczyn',
          'gmina_strzegom',
          'gmina_swierzawa',
          'gmina_zarow',
          'jawor',
          'swiebodzice'
        ].includes(this.props.district.prefix)
        ? 'desc-modal-cmentarze'
        : 'desc-modal'
      } ref={el => { this.sideDescrModal = el; }}>
        <div style={{ position: 'relative' }}>
          <div className={
            [
              'gmina_siekierczyn',
              'gmina_strzegom',
              'gmina_swierzawa',
              'gmina_zarow',
              'jawor',
              'swiebodzice'
            ].includes(this.props.district.prefix)
            ? 'desc-header-cmentarze perfectCenter'
            : 'desc-header perfectCenter'
          }>
            <div className="desc-header-text">
              <img src={xbutton} style={{ float: 'right' }} className="xbutton desc-close" onClick={this.handleClick} />
              {[
                'gmina_siekierczyn',
                'gmina_strzegom',
                'gmina_swierzawa',
                'gmina_zarow',
                'jawor',
                'swiebodzice'
              ].includes(this.props.district.prefix)
              ? this.headerContent()
              : this.state.buildingDrawPanel
                ? this.projektHeader()
                : (this.props.data ? this.headerContent() : this.headerSearch())
              }
            </div>
          </div>
          <div className="desc-content">
            {this.state.sideDescription.contentType == 'cmentarze' ? <CmentarzeForm /> : this.props.view && !this.state.buildingDrawPanel ?
              <div>
                {this.props.data ? this.renderImage() : null}
                {/* <TextExpander>In sed elementum quam. Aenean non ipsum maximus, ultricies risus in, sollicitudin mi. Phasellus posuere leo vel nulla commodo, sit amet sollicitudin nisi mattis. Integer ullamcorper mauris ligula, dignissim fringilla ex mattis pellentesque. Pellentesque at orci a mi luctus tincidunt nec nec justo. Aliquam cursus eleifend fermentum. Integer malesuada nisl dignissim, lobortis purus sed, finibus risus. Quisque vitae sagittis mauris. Pellentesque suscipit tempus lectus ut vehicula. Sed iaculis non velit et consectetur. Nunc congue consequat diam, nec bibendum metus mollis eget. Nullam rhoncus dolor et nunc iaculis semper. Vestibulum tristique ligula sit amet nibh molestie, nec fringilla magna porta. Sed venenatis neque lorem. Ut blandit tristique elit, consequat dapibus tortor lobortis a.</TextExpander> */}
                <div className="desc-features" ref={el => { this.featureSection = el; }}>
                  {this.props.data ? this.renderDescription() : <SearchInvest prefix={this.props.district.prefix} />}
                </div>
              </div>
            : null}
            {this.state.buildingDrawPanel ? <BuildingDraw renderEinvestInfo={this.state.einvestInfo ? ()=> this.renderEinvestInfo() : null}/> : null}
          </div>
        </div>
      </div>
    );
  }
}
const mapState = (state) => ({
  intl: state.intl,
  propKeys: state.postGeoData.additionalLayers,
  view: state.district.sideDescription.view,
  data: state.district.sideDescription.data,
  sideDescription: state.district.sideDescription,
  district: state.district.district,
  routing: state.routing,
  parcel_data: state.postGeoData.parcel_data,
  chosenParcel: state.district.chosenParcel,
  parcel_id: state.postGeoData.parcel_id,
  currentComposition: state.layers.currentMapComposition,
  parcelState: state.tools.parcelState,
  buildingDrawTool: state.tools.buildingDrawTool,
});

const mapDispatch = {
  toggleDrawBuilding,
  drawBuildingGetPoint,
  drawBuildingData,
  drawBuildingPDF,
  setPrintStatus,
  drawBuildingValidate,
  letsDrawSomeProject,
};

SideDescription.propTypes = {
  closeSideDescription: PropTypes.func,
  toggleDrawBuilding: PropTypes.func,
  drawBuildingGetPoint: PropTypes.func,
  drawBuildingData: PropTypes.func,
  drawBuildingPDF: PropTypes.func,
  setPrintStatus: PropTypes.func,
};
export default withStyles(s)(connect(mapState, mapDispatch)(SideDescription));



// WEBPACK FOOTER //
// src/components/Modals/SideDescription/SideDescription.js